var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningRed = function SvgWarningRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM10.75 11.0625C10.75 10.3721 11.3096 9.8125 12 9.8125C12.6904 9.8125 13.25 10.3721 13.25 11.0625V16.375C13.25 17.0654 12.6904 17.625 12 17.625C11.3096 17.625 10.75 17.0654 10.75 16.375V11.0625ZM12 6.0625C11.3096 6.0625 10.75 6.62214 10.75 7.3125C10.75 8.00286 11.3096 8.5625 12 8.5625C12.6904 8.5625 13.25 8.00286 13.25 7.3125C13.25 6.62214 12.6904 6.0625 12 6.0625Z",
    fill: "#DC2626"
  })));
};
export default SvgWarningRed;